// Base URL for pm-inventory API calls.
//
// The dashboard is served by the pm-inventory server itself (express.static on
// /dashboard), so requests go to the SAME ORIGIN by default. That keeps this
// build host-agnostic: Railway, another cloud host, or just `node index.js` on
// the PC all work from the same bundle with no rebuild and no URL edits.
//
// Override only when the CRA dev server runs separately from the API, e.g.
//   REACT_APP_API_BASE=https://pm-inventory-production.up.railway.app npm start
export const API = process.env.REACT_APP_API_BASE || '';
